import styled from 'styled-components';

export const Bold = styled.span`
  font-weight: 700;
`;

export const getContinueButtonText = ({ dynamicWidth }) => {
  if (dynamicWidth < 530) {
    return 'Activities.ContinueShort';
  }

  if (dynamicWidth < 1300) {
    return 'Activities.Continue';
  }

  return 'Activities.ContinueFull';
};
